import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import Navigation from './Navigation';
import BetaPricingPage from "./BetaPricingPage";
import Footer from './Footer';
import CaseStudy from './CaseStudy'; 
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import TectonicsPage from './tectonics/TectonicsPage';
import './App.css';

// Funnel pages get the logo-only header and the minimal footer.
const FUNNEL_PATHS = ['/tectonics'];

function AppShell() {
  const isFunnel = FUNNEL_PATHS.includes(useLocation().pathname.replace(/\/$/, ''));

  return (
    <div className="app">
      <Navigation logoOnly={isFunnel} staysDark={isFunnel} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/case-study" element={<CaseStudy />} /> 
        <Route path="/beta-pricing" element={<BetaPricingPage />} /> 
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/tectonics" element={<TectonicsPage />} />
      </Routes>
      <Footer minimal={isFunnel} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
